import { jsxs, jsx } from 'react/jsx-runtime';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../context/ViewContext/ViewContext.js';
import 'react';
import { shortenWalletAddress } from '../../shared/utils/functions/shortenWalletAddress/shortenWalletAddress.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { StatusDot } from '../StatusDot/StatusDot.js';
import { Typography } from '../Typography/Typography.js';

const UserAddress = ({ userProfile }) => {
    var _a;
    const lastVerifiedCredential = userProfile === null || userProfile === void 0 ? void 0 : userProfile.verifiedCredentials.find((verifiedCredential) => verifiedCredential.id === userProfile.lastVerifiedCredentialId);
    const walletAddress = shortenWalletAddress(lastVerifiedCredential === null || lastVerifiedCredential === void 0 ? void 0 : lastVerifiedCredential.address);
    const userAddress = ((_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.ens) === null || _a === void 0 ? void 0 : _a.name)
        ? userProfile.ens.name
        : walletAddress;
    return (jsxs("div", Object.assign({ className: 'user-address__container' }, { children: [jsx(StatusDot, { variant: 'green', containerClassName: 'user-address__status-dot' }), userAddress && (jsx(Typography, Object.assign({ variant: 'numbers_big', color: 'primary', className: 'user-address' }, { children: userAddress })))] })));
};

export { UserAddress };
